export enum AnalyseShowAllIndicesTabs {
  RISK_INDEX = 0,
  MAPLECROFT_RISK_VIEWS = 1,
  MY_RISK_VIEWS = 2,
}
